<template>
	<div class="view resume">

		<div class="filters">
			<StoreSelect @storeSelected="storeSelected" />
		</div>

		<div class="section">
			<div class="title">
				<i class="icon ico-router"></i>
				<h4 class="section-title">Portal Cautivo</h4>
			</div>
			<div class="actions">
				<a class="button quiet-sm" href="/contextual" v-if="!(group == 'analista' || group == 'marketing')">
					<p> Ir a Portal Cautivo</p>
					<i class="icon ico-chevron-right"></i>
				</a>
			</div>
		</div>

		<div id="satari" class="first-auto-row-four-row-grid">

			<ResumeCard
				title="Hoy"
				:icon="0"
				:sub="todayConnectionsTitle"
				:loader="todayConnectionsLoaded"
				:amount="todayTotalConnections"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
				/>

			<BarGraphCard
				title="Conexiones de hoy por hora"
				class="desktop bar-graph"
				height="200"
				:loader="todayConnectionsLoaded"
				:data="todayConnectionsBarChart"
				:periodItems="periodTodayConnections"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
				/>

			<ResumeCard
				title="Últimos 7 días"
				:sub="connectionsTitle"
				:loader="connectionsLoaded"
				:amount="totalConnections"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
				/>

			<BarGraphCard
				title="Conexiones de los últimos 7 días"
				class="desktop bar-graph"
				height="200"
				:loader="connectionsLoaded"
				:data="connectionsBarChart"
				:periodItems="periodConnections"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos" />

		</div>

		<div class="section">
			<div class="title">
				<i class="icon ico-sale"></i>
				<h4 class="section-title">Contenidos</h4>
			</div>
			<div class="actions">
				<a class="button quiet-sm" href="/contenido" v-if="group=='manager' || group=='marketing'">
					<p> Ir a Contenidos</p> 
					<i class="icon ico-chevron-right"></i>
				</a>
			</div>
		</div>

		<div id="content" class="four-rows-grid">

			<RankingCard class="ranking" title="Ranking de Contenidos" :data="offerRangkingData" :loader="rankingLoaded"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos" />

			<BarGraphCard title="Interacciones totales de los últimos 7 días" sub="" class="desktop bar-graph"
				:loader="offersClicksLoaded" :data="clicksBarChart" :periodItems="periodContent"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos" />

		</div>

		<div class="section" v-if="hasPresenceOption()">
			<div class="title">
				<i class="icon ico-presence"></i>
				<h4 class="section-title">Presencia</h4>
			</div>
			<div class="actions">
				<a class="button quiet-sm" href="/presencia" v-if=" !(group == 'analista' || group =='marketing') ">
					<p> Ir a Presencia</p> 
					<i class="icon ico-chevron-right"></i>
				</a>
			</div>
		</div>
		
		<div id="presence" class="three-rows-grid" v-if="hasPresenceOption()">
			<AmountInfraCard
				title="Últimos 7 días"
				@changeRange="showVisitorsData"
				:initRange="initRange"
				:endRange="endRange"
				:selectedRange="initRange"
				:store_id="store_id"
				tip="Cantidad de dispositivos detectados el día de ayer. Son visitantes los dispositivos detectados por 5 minutos o más durante el día, y transeúntes los dispositivos detectados por menos de dicho lapso de tiempo. El Capture Rate se calcula como el total de visitantes sobre el total de dispositivos detectados (visitantes + transeúntes)."
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
				/>

			<AmountDwellTime
				title="Distribución de visitantes por tiempo de permanencia"
				class="distribucion"
				:data="totalDwellTime"
				:loader="dwellTimeLoaded"
				tip="Porcentaje de visitantes que fue detectado por rango de tiempo de permanencia en el período seleccionado."
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
				/>
			<BarGraphCard
				title="Clasificación"
				tip="Muestra las cantidades de dispositivos detectados, tanto visitantes como transeúntes, del período seleccionado, por día."
				class="desktop bar-graph"
				:data="visitorsBarChart"
				:periodItems="periodInfra"
				:loader="visitorsLoaded"
				titleEmpty="Este gráfico no está disponible actualmente"
				captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
				/>

		</div>

		<div class="section">
			<div class="title">
				<i class="icon ico-api"></i>
				<h4 class="section-title">Clusters</h4>
			</div>
			<div class="actions">
				<a class="button quiet-sm" href="/clusters" v-if="!(group == 'analista' || group == 'marketing')">
					<p> Ir a Clusters</p>
					<i class="icon ico-chevron-right"></i>
				</a>
			</div>
		</div>
		<div id="cluster">
			<TableCard title="Performance por cluster" :sub="connectionsTitle" :loader="true" :data="clusterData"
				:titles="[
				{ 'name': 'Cluster', 'order': false, 'field': 'name' },
				{ 'name': 'Cantidad de Sedes', 'order': false, 'field': 'stores' },
				{ 'name': 'Conexiones', 'order': false, 'field': 'totalConnections' },
				{ 'name': 'Visitantes', 'order': false, 'field': 'totalVisitors' },
				{ 'name': 'Transeúntes', 'order': false, 'field': 'totalTrans' },]" />
		</div>
	</div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import { mapGetters } from 'vuex'

import StoreSelect from '@/components/StoreSelect'

import ResumeCard from '@/components/cards/ResumeCard'

import BarGraphCard from "@/components/cards/BarGraphCard"

import RankingCard from "@/components/cards/RankingCard"

import AmountInfraCard from '@/components/cards/AmountInfraCard'
import AmountDwellTime from '@/components/cards/AmountDwellTime'
import TableCard from '@/components/cards/TableCard'

export default {
	name: 'resume',
	components: {
		StoreSelect,
		ResumeCard,
		BarGraphCard,
		RankingCard,
		AmountInfraCard,
		AmountDwellTime,
		TableCard,
	},
	data: function () {
		return {
			group: localStorage.getItem('group'),
			periodTodayConnections: [],

			todayConnectionsBarChart: [],
			todayTotalConnections: 0,
			todayConnectionsLoaded: false,

			periodConnections: [],

			connectionsBarChart: [],
			totalConnections: 0,
			connectionsLoaded: false,

			periodContent: [],

			offersClicksLoaded: false,
			offerRangkingData: [],
			rankingLoaded: false,
			clicksBarChart: [],

			periodInfra: [],

			totalDwellTime: {
				fiveMins: 0,
				twentyMins: 0,
				sixtyMins: 0
			},
			dwellTimeLoaded: false,
			visitorsBarChart: [],
			visitorsLoaded: false,

			initRange: moment().subtract(7, 'd').format('YYYY-MM-DD'),
			endRange: moment().subtract(1, 'd').format('YYYY-MM-DD'),
			yesterday: moment().subtract(1, 'd').format('YYYY-MM-DD'),
			today: moment().format('YYYY-MM-DD'),
			store_id: 999999,
			clusterData: []
		}
	},
	mounted: function () {
		this.$store.dispatch("auth/setActive", "resume")
		this.$store.dispatch("offers/offerRequest", "999999")
			.then(() => {
				this.offersRanking()
				this.showOffersAnalytics()
			}, () => {
			})
		this.showTodayData()
		this.showConnectionsData()
		this.offersRanking()
		this.showOffersAnalytics()
		this.showDwellTime()
		this.clusterDate()
	},
	computed: {
		todayConnectionsTitle: function () {
			let monthNames = [
				"Ene", "Feb", "Mar",
				"Abr", "May", "Jun", "Jul",
				"Ago", "Sep", "Oct",
				"Nov", "Dic"
			]
			return moment().format('DD') + "-" + monthNames[moment().format('M') - 1]
		},

		connectionsTitle: function () {
			let monthNames = [
				"Ene", "Feb", "Mar",
				"Abr", "May", "Jun", "Jul",
				"Ago", "Sep", "Oct",
				"Nov", "Dic"
			]
			let initRangeTitle = moment().subtract(7, 'd').format('DD') + "-" + monthNames[moment().subtract(7, 'd').format('M') - 1]
			let endRangeTitle = moment().subtract(1, 'd').format('DD') + "-" + monthNames[moment().subtract(1, 'd').format('M') - 1]
			return initRangeTitle + " al " + endRangeTitle
		},

		offers: function() {
            return this.getOffers
        },
		...mapGetters({
			'getOffer': 'offers/getOffer',
			'getOffers': 'offers/allOffers',
		})
	},
	methods: {
		clusterDate: async function () {
			try {
				let headers = { 'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6' }
				const clusters = await axios(process.env.VUE_APP_CORE_HOST + "/api/store/cluster")
				_.each(clusters.data, async (cluster) => {
					const clusterDetail = {}
					clusterDetail["id"] = cluster.id
					clusterDetail["name"] = cluster.name
					clusterDetail["stores"] = cluster.stores.length
					clusterDetail["totalConnections"] = 0
					clusterDetail["totalVisitors"] = 0
					clusterDetail["totalTrans"] = 0
					_.each(cluster.stores, async (store) => {
						// Sesiones
						const sessions = await axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/sessions/?init_date=" + this.initRange + "&end_date=" + this.endRange + "&offer_id=999999&store_id=" + store.id, { headers: headers })
						const totalSession = _.sumBy(sessions.data, function (obj) {
							return obj.not_customer + obj.customer
						})
						clusterDetail["totalConnections"] = clusterDetail["totalConnections"] + totalSession

						// Visitors
						const visitors = await axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/visitors/?init_date=" + this.initRange + "&end_date=" + this.endRange + "&store_id=" + store.id, { headers: headers })
						const totalVisitor = _.sumBy(visitors.data, function (obj) { return obj.value })
						clusterDetail["totalVisitors"] = clusterDetail["totalVisitors"] + totalVisitor

						// Transeúntes
						const passerBy = await axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/passer_by/?init_date=" + this.initRange + "&end_date=" + this.endRange + "&store_id=" + store.id, { headers: headers })
						const totalPasserBy = _.sumBy(passerBy.data, function (obj) { return obj.value })
						clusterDetail["totalTrans"] = clusterDetail["totalTrans"] + totalPasserBy
					})
					this.clusterData.push(clusterDetail)
				})

			}
			catch (err) {
				console.log(err)
			}



		},
		checkValue: function (value, arr) {
			var status = false;

			for (var i = 0; i < arr.length; i++) {
				var name = arr[i];
				if (name == value) {
					status = true;
					break;
				}
			}

			return status;
		},
		storeSelected: function (val) {
			this.store_id = val
			this.showTodayData()
			this.showConnectionsData()
			this.offersRanking()
			this.showOffersAnalytics()
			this.showDwellTime()
		},

		showTodayData: function () {
			let headers = {
				'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
			}
			axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/sessions/?store_id=" + this.store_id + "&init_date=" + this.today + "&end_date=" + this.today, {
				headers: headers
			})
				.then((res) => {
					let todayConnections = 0;
					let periodToday = []
					let todayConnectionsData = [
						{
							'name': 'Conexiones',
							'data': []
						}
					]
					_.each(res.data, (value ) => {
						periodToday.push(value.period)
						todayConnectionsData[0].data.push(value.not_customer + value.customer)
						todayConnections = todayConnections + value.not_customer + value.customer
					})
					this.todayConnectionsLoaded = true
					this.todayTotalConnections = todayConnections
					this.periodTodayConnections = periodToday
					this.todayConnectionsBarChart = todayConnectionsData
				})
				.catch(() => {
					this.todayConnectionsLoaded = true;
					this.todayConnectionsBarChart = []
					this.todayTotalConnections = null
					console.log("error null")
				})
		},

		showConnectionsData: function () {
			let headers = {
				'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
			}
			axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/sessions/?store_id=" + this.store_id + "&init_date=" + this.initRange + "&end_date=" + this.endRange, {
				headers: headers
			})
				.then((res) => {
					let connections = 0;
					let periodConnections = []
					let connectionsData = [
						{
							'name': 'Conexiones',
							'data': []
						}
					]
					_.each(res.data, (value) => {
						periodConnections.push(value.period)
						connectionsData[0].data.push(value.not_customer + value.customer)
						connections = connections + value.not_customer + value.customer
					})
					this.connectionsLoaded = true
					this.totalConnections = connections
					this.periodConnections = periodConnections
					this.connectionsBarChart = connectionsData
				})
				.catch(() => {
					this.connectionsLoaded = true;
					this.totalConnections = null
					this.ConnectionsBarChart = []
				})
		},

		offersRanking: function () {
			let offersInitRange = moment().subtract(7, 'd').format('YYYY-MM-DD')
			let offersEndRange = moment().subtract(1, 'd').format('YYYY-MM-DD')
			let ranking = []

			let headers = {
				'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
			}
			let count = 0 
			axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/offers/ranking/?init_date=" + offersInitRange + "&end_date=" + offersEndRange + "&store_id=" + this.store_id, {
				headers: headers
			})
			.then((res) => {
				_.each(res.data, (value) => {
					let content = this.getOffer(value.name)[0]
					if (content) {
						var click_format = String(value.clicks).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
						if(count <= 10){
							ranking.push({ 'name': content.name, 'clicks': click_format })
							this.interactionNumber = this.interactionNumber + value.clicks
							count ++
						}
					}
				})
				
				if (ranking.length===0) {
					const offers = this.offers
					offers.forEach((offer, index) => {
						if (index <= 10)
						ranking.push({ 'name': offer.name, 'clicks': '0' })
					})
				}
				
				// if (ranking.length==0) {
				// 	// axios.get("https://st-portal.notros.io/api/offers", {
				// 	// })
				// 		// .then((res => {
				// 	this.interactionNumber = 0
				// 	const respiuesta=[
				// 		{"name": "Dirección de asuntos estudiantiles"},
				// 		{"name": "Santo Tomás en línea"},
				// 		{"name": "Accede ahora al portal docente"},
				// 		{"name": "Santo Tomás en línea"},
				// 		{"name": "Portal Colaboradores"},
				// 		{"name": "Accede ahora al portal"},
				// 		{"name": "#PostgradoUST Admisión 2023"},
				// 		{"name": "Accede ahora al portal"},
				// 		{"name": "¡Matricúlate con beneficios!"}	
				// 	]
				// 	respiuesta.forEach(element => {
				// 		ranking.push({ 'name': element.name, 'clicks': '0' })
				// 	})
				// 	this.offerRangkingData = ranking
					
				// } else {
				// 	console.log('ERRRRRRRRORRRR')
				// 	this.offerRangkingData = ranking
				// }
			})
			.catch(() => {
				this.rankingLoaded = true
				this.offerRangkingData = []
			})
			console.log('RANKINGGG')
			console.log(ranking)
			this.offerRangkingData = ranking
			this.rankingLoaded = true
		},

		showOffersAnalytics: function () {
			let offersInitRange = moment().subtract(7, 'd').format('YYYY-MM-DD')
			let offersEndRange = moment().subtract(1, 'd').format('YYYY-MM-DD')

			let headers = {
				'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
			}
			axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/offers/content/?init_date=" + offersInitRange + "&end_date=" + offersEndRange + "&offer_id=999999&store_id=" + this.store_id, {
				headers: headers
			})
				.then((res) => {
					let periodContent = []
					let periodRange = moment(offersEndRange).diff(moment(offersInitRange), 'days') + 1
					let clicksChartData = []
					let offerIds = []

					// Se genera arreglo con todos los días dentro del rango seleccionado

					for (let index = 0; index < periodRange; index++) {
						if (index > 0) {
							periodContent.push(moment(this.initRange).add(index, 'days').format('DD-MM-YYYY'))
						} else {
							periodContent.push(moment(this.initRange).format('DD-MM-YYYY'))
						}
					}

					// Se genera el arreglo con todas las ofertas

					_.each(res.data, (value) => {
						let content = this.getOffer(value.offer_id)[0]
						if (content && offerIds.filter(offer => offer == value.offer_id).length == 0) {
							offerIds.push(value.offer_id)

							let click = {
								'name': content.name,
								'offer_id': value.offer_id,
								'data': []
							}

							clicksChartData.push(click)
						}
					})

					_.each(periodContent, (date) => {
						let dateEvents = res.data.filter(event => event.period == date)

						_.each(clicksChartData, (offerEvent, index) => {
							let clickEvents = dateEvents.filter(event => event.offer_id == offerEvent.offer_id)
							if (clickEvents.length > 0) {
								clicksChartData[index].data.push(clickEvents.reduce((a, b) => a + b.clicks, 0))
							} else {
								clicksChartData[index].data.push(0)
							}
						})
					})

					this.periodContent = periodContent
					this.clicksBarChart = clicksChartData
					this.offersClicksLoaded = true
				})
				.catch(() => {
					this.offersClicksLoaded = true
					this.clicksBarChart = []
				})
		},

		showDwellTime: function () {
			let headers = {
				'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
			}
			axios.get(process.env.VUE_APP_ANALYTICS_HOST + "/api/dwell_time/?store_id=" + this.store_id + "&init_date=" + this.initRange + "&end_date=" + this.endRange, {
				headers: headers
			})
				.then((res) => {
					let sum5Min = 0
					let sum20Min = 0
					let sum1Hour = 0
					_.each(res.data, (value) => {
						// if (value.name == 'DWELL_FIVE_TO_TWENTY_MINUTES') {
						if (value.name == 'DWELL_FIVE_TO_SIXTY_MINUTES') {
							sum5Min = sum5Min + value.value
						// } else if (value.name == 'DWELL_TWENTY_TO_SIXTY_MINUTES') {
						} else if (value.name == 'DWELL_ONE_TO_SIX_HOURS') {
							sum20Min = sum20Min + value.value
						// } else if (value.name == 'DWELL_ONE_TO_SIX_HOURS' || value.name == 'DWELL_SIX_PLUS_HOURS') {
						} else if (value.name == 'DWELL_SIX_PLUS_HOURS' || value.name == 'DWELL_SIX_PLUS_HOURS') {
							sum1Hour = sum1Hour + value.value
						}
					})
					this.totalDwellTime.fiveMins = sum5Min
					this.totalDwellTime.twentyMins = sum20Min
					this.totalDwellTime.sixtyMins = sum1Hour
					this.dwellTimeLoaded = true
				})
				.catch(() => {
					this.dwellTimeLoaded = true
					this.totalDwellTime = []
				})
		},

		showVisitorsData: function (init, end, passersBy, visitors) {
			this.visitorsLoaded = false

			let totalVisitors = 0
			let periodInfra = []

			let visitorsChartData = [
				{
					'name': 'Transeúntes',
					'data': []
				},
				{
					'name': 'Visitantes',
					'data': []
				}
			]

			_.each(passersBy, (value) => {
				periodInfra.push(value.period)
				visitorsChartData[0].data.push(value.value)
			})

			_.each(visitors, (value) => {
				visitorsChartData[1].data.push(value.value)
				totalVisitors = totalVisitors + value.value
			})
			this.visitorsBarChart = visitorsChartData
			this.periodInfra = periodInfra
			this.visitorsLoaded = true
		},

		hasPresenceOption: function(){
            const client = process.env.VUE_APP_CLIENT_NAME
            const presenceClients = ['duoc']
            return presenceClients.includes(client.toLocaleLowerCase())
        }
	}
}
</script>

<style lang="sass">
.resume
	.section
		@include mobile-landscape
			grid-column: 2/4
		@include tablet-portrait
			grid-column-start: 2
			grid-column-end: 6
.section .title
	display: flex
	align-items: center
	.icon
		color: $white
		font-size: 24px
		margin: $xxs
		display: flex
		@include tablet-landscape
			font-size: 22px
		@include mobile
			font-size: 16px
		@include mobile-landscape
			font-size: 16px
	.section-title
		@include mobile
			width: 310px
			font-size: 16px

.actions 
	flex-direction: row-reverse
.resume .multiselect
	@include mobile
		width: 100%

.three-rows-grid
	grid-template-columns: repeat(3, minmax(0, 1fr))

.four-rows-grid
	grid-template-columns: repeat(4, minmax(0, 1fr))
	.ranking
	@include tablet-portrait
		grid-column: 1/5

.first-auto-row-four-row-grid
	grid-template-columns: 1fr repeat(3, minmax(0, 1fr))



.three-rows-grid, .four-rows-grid, .first-auto-row-four-row-grid
	display: grid
	grid-column-start: 2
	grid-column-end: span 4
	grid-gap: 8px
	@media (max-width: $tablet)
		grid-template-columns: repeat(2, minmax(0, 1fr))
		grid-column-end: span 2
		.card-data, .card-data.sm, .card-data.md, .card-data.lg, .card-data.xl
			grid-column-start: auto
			grid-column-end: span 2
		.resume-icon
			grid-column-end: span 1
#satari
	@include mobile-landscape
		.bar-graph
			display: none
	@include tablet-portrait
		grid-column: 2/6
		grid-template-columns: repeat(5, minmax(0, 1fr))
		.resume-icon
			grid-column: 1/2
		.bar-graph
			display: block
			grid-column: 2/6
#content
	@include mobile-landscape
		.bar-graph
			display: none
	@include tablet-portrait
		grid-template-columns: repeat(5, minmax(0, 1fr))
		grid-column: 2/6
		.bar-graph
			display: block
			grid-column: 3/6
#presence
	@include mobile-landscape
		.bar-graph
			display: none
	@include tablet-portrait
		grid-template-columns: repeat(4, minmax(0, 1fr))
		grid-column: 2/6
		.bar-graph
			display: block
			grid-column: 1/5
#cluster
	grid-column: 2/6
	@include mobile
		grid-column: 2/4
	.table-card table th
		width: calc(100%/5)
</style>